"use client";
import { Tooltip } from "@/_components/lib/ui/tooltip";
import { Image as ChakraImage } from "@chakra-ui/react";
import { IMAGE_MAP, ImageKey } from "./imageList";

interface PlaceholderImageProps {
  image: ImageKey;
  width?: number | string;
  height?: number | string;
  tooltip?: string;
  alt?: string;
  objectFit?: "cover" | "contain" | "fill" | "none" | "scale-down";
  borderRadius?: string;
  grayscale?: boolean;
}

export const PlaceholderImage = ({
  image,
  width = "100rem",
  height = "fit-content",
  tooltip,
  alt,
  objectFit = "cover",
  borderRadius = "md",
  grayscale = true,
}: PlaceholderImageProps) => {
  const baseUrl =
    process.env.NEXT_PUBLIC_CLOUDFRONT_CDN_URL ||
    "https://d137n9fqai29d3.cloudfront.net";
  if (!baseUrl) {
    throw new Error("NEXT_PUBLIC_CLOUDFRONT_CDN_URL is not set");
  }
  const cdnUrl = `${baseUrl}/images`;

  const imageElement = (
    <ChakraImage
      src={`${cdnUrl}/${IMAGE_MAP[image]}`}
      alt={alt || image}
      width={width}
      height={height}
      objectFit={objectFit}
      borderRadius={borderRadius}
      loading="lazy"
      filter={grayscale ? "grayscale(100%)" : "none"}
    />
  );

  return tooltip ? (
    <Tooltip
      content={tooltip}
      openDelay={300}
      positioning={{ placement: "top" }}
    >
      {imageElement}
    </Tooltip>
  ) : (
    imageElement
  );
};

export { IMAGE_MAP };
